import { Component, OnInit, Input, ViewEncapsulation, ChangeDetectorRef } from '@angular/core';
import { AgentlocationService } from '../../services/agent_location/agentlocation.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import 'rxjs/add/operator/map';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatSortModule } from '@angular/material/sort';
import { MatButtonModule, MatCheckboxModule } from '@angular/material';
import { Sort } from '@angular/material';
import { MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
import { PageEvent } from '@angular/material';
import { ViewChild } from '@angular/core';
import { MatFormFieldModule } from '@angular/material';
import { Observable } from 'rxjs/Observable';
import { MatInputModule } from '@angular/material';
import { MatPaginatorIntl } from '@angular/material';
import { SearchTermservice } from '../../services/search/search-service.service';
import { MatRadioModule, MatRadioButton } from '@angular/material/radio';

@Component({
  selector: 'app-agentlocation',
  templateUrl: './agentlocation.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./agentlocation.component.css']
})
export class AgentlocationComponent implements OnInit {
  agentDetails: any;
  agentName: string;
  data: boolean = true;
  message: string;
  public agentLocationResults: any[] = [];
  private agentId: any;
  sortedData;
  length: any;
  pageSize = 10;
  public role: string;
  clientDisable: any;
  clientHidden: any;
  displayedColumns = ['LocationId', 'LocationType', 'Address1', 'City', 'State', 'PostalCode', 'OfficePhone', 'ManagerName', 'Remediation'];
  dataSource: MatTableDataSource<LocationData>;
  ispaginationFlag: boolean = false;
  errMsg;
  errFlag: boolean = false;
  locationFlags: string[] = ['Active Locations', 'Inactive Locations'];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  flagSelected = 'Active Locations';
  flag: any;

  constructor(private http: Http, private router: Router, private locationService: AgentlocationService, private searchTermservice: SearchTermservice) {
  }

  // MatPaginator Output
  pageEvent: PageEvent;

  ngOnInit() {
    this.agentId = localStorage.getItem("AgentId");
    this.agentName = localStorage.getItem("AgentName");
    this.searchTermservice.detailsOfAgent(this.agentId).subscribe(res => {
      this.agentDetails = res;
      this.getLocationDocs();
    })
    this.role = localStorage.getItem("Role")
    if (this.role === "PC Client") {
      this.clientDisable = true;
      this.clientHidden = true;
    } else {
      this.clientDisable = false;
      this.clientHidden = false;
    }

  }
  getLocationDocs() {
    this.locationService.getAgentLocationDetails(this.agentId, this.flagSelected).subscribe(res => {
      if (res.Status == 200 && res.vendorLocationDetails !== undefined && res.vendorLocationDetails.length > 0) {
        this.data = true;
        this.locationService.getRemediationDetails(this.agentId).subscribe(details => {
          for (let i = 0; i < res.vendorLocationDetails.length; i++) {
            res.vendorLocationDetails[i].Address1 = res.vendorLocationDetails[i].Address1.toLowerCase();
            for (let j = 0; j < details.Locations.length; j++) {
              if (details.Locations[j].LocationId == res.vendorLocationDetails[i].LocationId) {
                res.vendorLocationDetails[i].Remediation = details.Locations[j].Remediation;
              }
            }
            this.agentLocationResults.push(res.vendorLocationDetails[i]);
          }
          this.dataSource = new MatTableDataSource(this.agentLocationResults);
          this.length = this.agentLocationResults.length;
          if (this.length <= 10) {
            this.ispaginationFlag = false;
          }
          else {
            this.ispaginationFlag = true;
          }
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          const paginatorIntl = new MatPaginatorIntl();
          paginatorIntl.itemsPerPageLabel = 'Items per page';
          paginatorIntl.nextPageLabel = 'Next page';
          paginatorIntl.previousPageLabel = 'Previous page';

          paginatorIntl.getRangeLabel = (page: number, pageSize: number, length: number) => {
            length = this.length;
            if (length == 0 || pageSize == 0) {
              return `0 van ${length}`;
            }
            length = Math.max(length, 0);
            const startIndex = page * pageSize;
            // If the start index exceeds the list length, do not try and fix the end index to the end.
            const endIndex = startIndex < length ?
              Math.min(startIndex + pageSize, length) :
              startIndex + pageSize;
            const round = Math.ceil(length / 10)
            return `${(startIndex / 10) + 1}  of ${round}`;
          }
          this.dataSource.paginator._intl = paginatorIntl;
          this.message = '';
        }, err => {
          this.errMsg = err;
          this.errFlag = true;
        });
      } else if (res.vendorLocationDetails !== undefined && res.vendorLocationDetails.length == 0) {
        this.data = false;
        this.ispaginationFlag = false;
        this.message = "No locations found";
        this.dataSource = null;
      }

    }, err => {
      this.errMsg = err;
      this.errFlag = true;
    });
  }

  selectedLocation(locationId) {
    localStorage.setItem('LocationId', locationId);
    this.router.navigate(['agent/location', this.agentId, 'LocationSummary', locationId]);
  }

  locationTypeSelected(type) {
    this.agentLocationResults = [];
    this.locationService.getAgentLocationDetails(this.agentId, type).subscribe(res => {
      if (res.Status == 200 && res.vendorLocationDetails !== undefined && res.vendorLocationDetails.length > 0) {
        this.data = true;
        for (let i = 0; i < res.vendorLocationDetails.length; i++) {
          res.vendorLocationDetails[i].Address1 = res.vendorLocationDetails[i].Address1.toLowerCase();
          this.agentLocationResults.push(res.vendorLocationDetails[i]);
        }
        this.dataSource = new MatTableDataSource(this.agentLocationResults);
        this.length = this.agentLocationResults.length;
        if (this.length <= 10) {
          this.ispaginationFlag = false;
        }
        else {
          this.ispaginationFlag = true;
        }
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        const paginatorIntl = new MatPaginatorIntl();
        paginatorIntl.itemsPerPageLabel = 'Items per page';
        paginatorIntl.nextPageLabel = 'Next page';
        paginatorIntl.previousPageLabel = 'Previous page';

        paginatorIntl.getRangeLabel = (page: number, pageSize: number, length: number) => {
          length = this.length;
          if (length == 0 || pageSize == 0) { return `0 van ${length}`; }
          length = Math.max(length, 0);
          const startIndex = page * pageSize;
          // If the start index exceeds the list length, do not try and fix the end index to the end.
          const endIndex = startIndex < length ?
            Math.min(startIndex + pageSize, length) :
            startIndex + pageSize;
          const round = Math.ceil(length / 10)
          return `${(startIndex / 10) + 1}  of ${round}`;
        }
        this.dataSource.paginator._intl = paginatorIntl;
        this.message = '';
      }
      else if (res.vendorLocationDetails !== undefined && res.vendorLocationDetails.length == 0) {
        this.data = false;
        this.ispaginationFlag = false;
        this.message = "No locations found";
        this.dataSource = null;
      }
    }, err => {
      this.errMsg = err;
      this.errFlag = true;
    });
  }

  // getRemediationDetailsData(){
  //   this.locationService.getRemediationDetails(this.agentId).subscribe(res => {
   //   }, err => {
  //     this.errMsg = err;
  //     this.errFlag = true;
  //   });
  // }



}

export interface LocationData {
  LocationId: number;
  LocationType: string;
  Address1: string;
  OfficePhone: string;
  ManagerName: string;
  City: string;
  State: string;
  PostalCode: number;
  Remediation: string;
}




// WEBPACK FOOTER //
// ./src/app/components/agentlocation/agentlocation.component.ts